import { ICellRendererParams } from 'ag-grid-community';
import { UnderlyingTagBase } from 'components/underlying-tag';
import { SmartQuoteParsingResult } from 'state/workspaces/smart-quote/model';

type UnderlyingBadgeProps = ICellRendererParams<SmartQuoteParsingResult, string[]>;

export function UnderlyingBadge({ value: underlyings }: UnderlyingBadgeProps) {
  if (!underlyings || underlyings.length === 0) {
    return null;
  }

  return (
    <div className="d-flex flex-wrap gap-1 h-100 align-items-center">
      {underlyings.map(underlying => (
        <UnderlyingTagBase key={underlying} label={underlying} isReadOnly size="lg" />
      ))}
    </div>
  );
}

export default UnderlyingBadge;
